const locale = {
  placeholder: 'Hora',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/pt_BR.tsx